import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { primaryLinks, serviceLinks } from "./navLinks";

function mobileItemClass(active) {
  return `block py-3 px-4 rounded-lg text-sm font-medium ${
    active ? "text-cyan-400 bg-cyan-400/10" : "text-gray-300 hover:text-white hover:bg-white/5"
  }`;
}

export default function MobileNav({ open, onClose }) {
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  const isServicesActive = serviceLinks.some((l) => location.pathname === l.path);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          className="lg:hidden glass border-t border-white/10"
          data-testid="mobile-menu"
        >
          <div className="px-4 py-4 space-y-2">
            <Link
              to="/"
              className={mobileItemClass(location.pathname === "/")}
              onClick={onClose}
            >
              Home
            </Link>

            <button
              className={`flex items-center justify-between w-full py-3 px-4 rounded-lg text-sm font-medium ${
                isServicesActive
                  ? "text-cyan-400 bg-cyan-400/10"
                  : "text-gray-300 hover:text-white hover:bg-white/5"
              }`}
              onClick={() => setServicesOpen((v) => !v)}
            >
              Services
              <ChevronDown
                size={14}
                className={`transition-transform ${servicesOpen ? "rotate-180" : ""}`}
              />
            </button>
            <AnimatePresence>
              {servicesOpen && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  className="pl-4 space-y-1"
                >
                  {serviceLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className={`block py-2.5 px-4 rounded-lg text-sm ${
                        location.pathname === link.path
                          ? "text-cyan-400 bg-cyan-400/10"
                          : "text-gray-400 hover:text-white hover:bg-white/5"
                      }`}
                      onClick={() => {
                        onClose();
                        setServicesOpen(false);
                      }}
                    >
                      {link.name}
                    </Link>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>

            {primaryLinks
              .filter((l) => l.path !== "/")
              .map((l) => (
                <Link
                  key={l.path}
                  to={l.path}
                  className={mobileItemClass(location.pathname === l.path)}
                  onClick={onClose}
                >
                  {l.name}
                </Link>
              ))}

            <Link to="/contact" onClick={onClose}>
              <Button
                data-testid="mobile-nav-cta-button"
                className="btn-primary w-full mt-4 text-white font-medium"
              >
                Get Started
              </Button>
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
